import { render, staticRenderFns } from "./_challengeid.vue?vue&type=template&id=2e338a54&"
import script from "./_challengeid.vue?vue&type=script&lang=ts&"
export * from "./_challengeid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports